import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
export function DetailRow({ label, value }) {
    return (_jsxs("div", { children: [_jsx("div", { className: "text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-1", children: label }), _jsx("div", { className: "text-slate-900 dark:text-slate-200 break-words", children: value })] }));
}
